import { apiClient as api } from "./httpClient";
import { ReportProfessionalItem } from "./reportsService";

/** Situação de uma sessão na leitura do relatório (RN-226) — uma só por linha. */
export type StatementSituation =
  | "attended"
  | "cancelled_patient"
  | "cancelled_professional"
  | "cancelled_clinic"
  | "no_show"
  | "scheduled"
  | "unreported";

export interface ProfessionalStatementItem {
  scheduleId: string;
  /** yyyy-MM-dd no relógio da entidade */
  date: string;
  startTime: string;
  endTime: string;
  patientId: string;
  patientName: string;
  serviceName: string;
  confirmation: string;
  presence: string;
  situation: StatementSituation;
  evolved: boolean;
  /** Evolução ativa da sessão (alimenta a impressão) */
  evolutionId: string | null;
  /** Compareceu e ainda sem evolução: a fila do profissional */
  evolutionPending: boolean;
  /** Confirmação e presença permitem evolução (configuração da agenda) e ainda não há uma */
  canEvolve: boolean;
  /** Só existe quando o paciente compareceu (RN-215a) */
  payout: number;
}

export interface ProfessionalStatementTotals {
  totalSchedules: number;
  attended: number;
  cancelledByPatient: number;
  cancelledByProfessional: number;
  cancelledByClinic: number;
  noShow: number;
  evolved: number;
  evolutionPending: number;
  payout: number;
  attendanceRate: number;
  evolvedRate: number;
}

export interface ProfessionalStatementMonth {
  month: string;
  attended: number;
  cancelledByPatient: number;
  cancelledByProfessional: number;
  payout: number;
}

export interface ProfessionalStatementResponse {
  /** 'own' = sem filtro de profissional (o servidor recorta); 'entity' = gestão escolhe */
  scope: "own" | "entity";
  professionals: ReportProfessionalItem[];
  professionalId: string | null;
  professionalName: string;
  totals: ProfessionalStatementTotals;
  monthly: ProfessionalStatementMonth[];
  items: ProfessionalStatementItem[];
}

export interface ProfessionalStatementParams {
  from: string;
  to: string;
  professionalId?: string;
}

const query = (p: ProfessionalStatementParams) => ({
  from: p.from,
  to: p.to,
  professionalId: p.professionalId || undefined,
});

export const professionalStatementService = {
  get: async (params: ProfessionalStatementParams): Promise<ProfessionalStatementResponse> => {
    const response = await api.get("/reports/professional-statement", { params: query(params) });
    return response.data;
  },

  exportXlsx: async (params: ProfessionalStatementParams): Promise<Blob> => {
    const response = await api.get("/reports/professional-statement/export", {
      params: query(params),
      responseType: "blob",
    });
    return response.data;
  },
};
